import { lazy, Suspense } from 'react';
import { Layout } from 'components/themes/v1';

const JobApply = lazy(() => import('modules/job/JobApply'));

const JobApplyPage = (props) => (
  <Layout>
    <Suspense fallback={null}>
      <JobApply />
    </Suspense>
  </Layout>
);

export default JobApplyPage;
